import React from 'react';
import { SuspenseWrapper } from './SuspenseWrapper';
import { views } from '../utils/view';
import { useParams } from 'react-router';
import { NotFoundRoute } from './NotFoundRoute';
import BrazeRedirect from './redirects/BrazeRedirect';

type ViewRouteProps = {
  viewId: string;
  children: React.ReactNode;
};

const AuthRequired = React.lazy(() => import('./redirects/AuthRedirect'));

const ViewRoute: React.FC<ViewRouteProps> = ({ children }) => {
  return (
    <SuspenseWrapper>
      <AuthRequired>{children}</AuthRequired>
    </SuspenseWrapper>
  );
};

const PackageComponent = React.lazy(() => import('../View/PackageContainer'));
export const PackageRoute = () => {
  const { viewId } = useParams();

  if (!viewId?.length) {
    return <NotFoundRoute />;
  }

  return (
    <ViewRoute viewId={viewId}>
      <PackageComponent packageId={viewId} />
    </ViewRoute>
  );
};

const LiveComponent = React.lazy(() => import('../View/LiveContainer'));
export const LiveRoute = () => (
  <ViewRoute viewId={views.TV_LIVE}>
    <LiveComponent />
  </ViewRoute>
);

const FavoritesComponent = React.lazy(
  () => import('../Favorites/FavoritesViewContainer')
);
export const FavoritesRoute = () => (
  <ViewRoute viewId={views.FAVORITES}>
    <FavoritesComponent />
  </ViewRoute>
);

const RadioFront = React.lazy(() => import('../RadioHome/RadioHome'));
export const RadioFrontRoute = () => {
  return (
    <ViewRoute viewId={views.RADIO_FRONT}>
      <BrazeRedirect>
        <RadioFront />
      </BrazeRedirect>
    </ViewRoute>
  );
};
